import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {header} from "./header";
import { grey_keywords_template } from "../components/templates/grey_keywords_template";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";

declare var ko: any;
declare var page: any;

export class grey_keywords extends vnModule_knockoutJS{

   
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];

    protected XHRHdlSaveKeyword: XMLHttpRequestHandler;

    protected pagination: pagination_template;
    public grey_keywords_template: grey_keywords_template;

    protected getModuleName(): string {
        return "grey_keywords";
    }

    public fillPage() : void{
        this.filterList();


    }

    public buildContent(): Array<Element> {

        this.grey_keywords_template = new grey_keywords_template("grey_keywords", this.viewModel, this as grey_keywords);
        return [this.grey_keywords_template.build()];
    }

    private filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.grey_keywords_template.builtTemplate.children.namedItem("list-results"));
        let subVM = JSON.parse(ko.toJSON(this.grey_keywords_template.getViewModelForRequest()));
        let url: string = '/api/grey-keywords/get-list/';
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(subVM)]);

        
        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetFullGreyWordsListReturn;
        this.XHRHdl.execute();
        
    }

    protected onGetFullGreyWordsListReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.updateList(response);
                obj.grey_keywords_template.setBrandList(response.brands);
            });
            obj.loadingOut(obj.grey_keywords_template.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(responseParsed: any){

       

        this.grey_keywords_template.setFullGreyWordsList(responseParsed.paginatedResults.data);

        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.grey_keywords_template.setResultInfo(responseParsed.paginatedResults.totalCount, responseParsed.paginatedResults.totalPage,execTime );

        // update the paginator
        this.viewModel.grey_keywords.pagination.itemCount(responseParsed.paginatedResults.totalCount);
    }

    public saveKeyword(){

        if (this.XHRHdlSaveKeyword) {
            this.XHRHdlSaveKeyword.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.grey_keywords_template.builtTemplate.children.namedItem("list-results"));
        let subVM = JSON.parse(ko.toJSON(this.grey_keywords_template.getViewModelForRequest()));
        let url: string = '/api/grey-keywords/save-keyword/';
        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(subVM)]);

        
        this.XHRHdlSaveKeyword = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdlSaveKeyword.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdlSaveKeyword.onReadyStateFunction = this.onSaveKeywordReturn;
        this.XHRHdlSaveKeyword.execute();
    }

    protected onSaveKeywordReturn(req, obj): Function {

        return () => {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.updateList(response);
                obj.grey_keywords_template.setBrandList(response.brands);
            });
            obj.loadingOut(obj.grey_keywords_template.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected paginationOnPageClick(){

        this.filterList();
    }
    
    protected greyKeywordsReorder(){

        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterSimpleOnChange(){

        this.viewModel.grey_keywords.pagination.pageNumber(1);
        this.filterList();
    }
}


// WEBPACK FOOTER //
// ./js/modules/grey_keywords.ts